
import { lastSearch } from "../../actions";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import store from "store";

const SearchLastCriteria = () => {

    const dispatch = useDispatch();
    const { translate, lang } = useSelector(state => state.general);
    const latestSearch = store.get("searchCriteria");

    return (
        <div className="searchBarLastSearch">
            {latestSearch &&
                <React.Fragment>
                    {latestSearch.length > 0 && <span className="searchBarLastSearch_title">{translate("search_slug")}:</span>}
                    {latestSearch.length > 0 && latestSearch.reverse().map((item, index) => (
                        <Link key={index} to={`/${translate("search_slug")}/${item.location[0].slug}/${item.keyword && item.keyword + "/"}${translate("page", lang)}=1${item.categoryID ? `?category=${item.categoryID}` : ''}`}>
                            <span onClick={() => dispatch(lastSearch([]))}>
                                {item.keyword && translate("naar") + " " + item.keyword} {translate("in")} {item.location[0].sub_municipality_name ? item.location[0].sub_municipality_name : item.location[0].name}
                            </span>
                        </Link>
                    ))}
                </React.Fragment>
            }
        </div>
    );
};

export default SearchLastCriteria;
